import { ReactElement } from 'react'
import numeral from 'numeral'
import { Typography } from '@mui/material'

interface UnitConvertedValueTypographyProps {
  value: number | undefined
  unitLabel: string
  conversionFactor: number
  numeralFormatter?: string
}

const UnitConvertedValueTypography = ({
  value,
  unitLabel,
  conversionFactor,
  numeralFormatter = '0',
}: UnitConvertedValueTypographyProps): ReactElement => {
  const displayValue = value
    ? numeral(Number(value) * conversionFactor).format(numeralFormatter)
    : '-'

  return <Typography fontSize={'inherit'}>{`${displayValue} ${unitLabel}`}</Typography>
}

export default UnitConvertedValueTypography
